import React from 'react'
import { useSessionsLandingPageData } from '../SessionsLandingPageDataProvider'
import { InstructorBio } from './InstructorBio'

interface InstructorBioProps {
  campSlug: string
  nameplate: string
  instructorTitle?: string
}

export const InstructorBioConnected = ({
  campSlug,
  nameplate,
  instructorTitle,
}: InstructorBioProps) => {
  const { instructorBio } = useSessionsLandingPageData()

  return (
    <InstructorBio
      instructorBio={instructorBio}
      nameplate={nameplate}
      instructorTitle={instructorTitle}
      campSlug={campSlug}
    />
  )
}
